import { useCallback, useMemo } from "react"

import { useParams } from "react-router-dom"

import { API_MODULE_HORIZONTAL_SIGNING, HorizontalSigningMultiCampaignsSource } from "@l2r-front/l2r-app-city"
import { useCampaign, useCampaigns } from "@l2r-front/l2r-shared-campaign"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { CampaignModules } from "../../constants/modules"
import { CAMPAIGNS_COUNT_PER_PAGE, NETWORK_CAMPAIGNS_PAGE } from "../../constants/urlParams"

type MultiCampaignsSourceProps = {
    children: React.ReactNode
    cluster?: boolean
    clusterMaxZoom?: number
    hoveredCampaignId?: string
    hoveredChildren?: React.ReactNode
    id: string
    iconOffset?: number
}

export function MultiCampaignsSource(props: MultiCampaignsSourceProps) {

    const {
        iconOffset = 28,
        ...otherProps
    } = props

    const { getParam } = useUrlParams()
    const { campaignId } = useParams()

    const page = useMemo(() => {
        return parseInt(getParam(NETWORK_CAMPAIGNS_PAGE) || "1") || 1
    }, [getParam])

    const { data: campaign } = useCampaign(campaignId)

    const { data: campaignsList } = useCampaigns(
        {
            offset: (page - 1) * CAMPAIGNS_COUNT_PER_PAGE,
            limit: CAMPAIGNS_COUNT_PER_PAGE,
        },
        { enabled: !campaignId },
    )

    const campaigns = useMemo(() => {
        if (campaignId) {
            if (!campaign) {
                return []
            }

            return [{
                id: campaign.uuid,
                campaignType: campaign.campaign_type,
                color: campaign.color,
                queryParameters: {},
            }]
        }

        return (campaignsList?.results || [])
            .filter(listedCampaign => listedCampaign.campaign_type === API_MODULE_HORIZONTAL_SIGNING)
            .map(listedCampaign => ({
                id: listedCampaign.uuid,
                campaignType: listedCampaign.campaign_type,
                color: listedCampaign.color,
            }))
    }, [campaignId, campaign, campaignsList])

    const getIconComponent = useCallback((type: string) => {
        return CampaignModules.find(module => module.module === type)?.icon
    }, [])

    return <HorizontalSigningMultiCampaignsSource
        {...otherProps}
        campaigns={campaigns}
        getIconComponent={getIconComponent}
        iconOffset={iconOffset}
    />
}
